import React, { useContext } from 'react';
import { Content } from './styles';
import { ThemeContext } from 'styled-components';

const Header = props => {
  return (
    <Content height={34} width={1060} speed={1.2} {...props}>
      <rect x="8" y="8" rx="0" ry="0" width={15} height={12} />
      <rect x="60" y="8" rx="0" ry="0" width={26} height={12} />
      <rect x="350" y="8" rx="0" ry="0" width={26} height={12} />
      <rect x="695" y="8" rx="0" ry="0" width={60} height={12} />
      <rect x="820" y="8" rx="0" ry="0" width={35} height={12} />
      <rect x="1020" y="8" rx="0" ry="0" width={30} height={12} />
    </Content>
  );
};
const TableRow = props => {
  const random = Math.random() * (1 - 0.7) + 0.7;
  return (
    <Content
      height={34}
      width={1060}
      speed={1.2}
      {...props}
      viewBox="0 0 1060 34"
    >
      <circle cx="20" cy="12.5" r="12" />
      <rect x="60" y="8" rx="6" ry="6" width={250 * random} height="10" />
      <rect x="350" y="8" rx="6" ry="6" width={200 * random} height="10" />
      <rect x="695" y="8" rx="6" ry="6" width={40 * random} height="10" />
      <rect x="820" y="6" rx="3" ry="3" width={80} height="16" />
      <rect x="1010" y="8" rx="3" ry="3" width={11} height="10" />
      <rect x="1030" y="8" rx="3" ry="3" width={11} height="10" />
    </Content>
  );
};

const Table = ({ type }) => {
  const themeContext = useContext(ThemeContext);

  return (
    <>
      <Header
        backgroundColor={themeContext?.loadingTableColor}
        foregroundColor={themeContext?.loadingTableColor}
        primaryopacity={1}
        secondaryopacity={0.6}
      />
      {Array(7)
        .fill('')
        .map((e, i) => (
          <TableRow
            key={i}
            style={{ opacity: Number(2 / i).toFixed(1) }}
            backgroundColor={themeContext?.loadingTableColor}
            foregroundColor={themeContext?.loadingTableColor}
            primaryopacity={1}
            secondaryopacity={0.6}
          />
        ))}
    </>
  );
};

export default Table;
